<template>
  <!-- 致友计划订单结算卡片 -->
  <div class="cartItem" @click.stop>
    <div class="imgBox">
      <img :src="data.imgSrc" alt="图片缺失" />
    </div>
    <div class="orderIfnBox">
      <van-row>
        <van-col span="20">
          <span class="planName">{{ data.productName }}</span>
        </van-col>
        <van-col span="4">
          <div style="text-align:right;color:#666">x{{ data.num }}</div></van-col
        >
      </van-row>
      <div class="dealerNameBox">
        <div class="dealerName ellipsis">
          <template v-if="data.carInfoObj && data.carInfoObj.intention">
            车辆：暂不选择车辆
          </template>
          <template v-else>
            <span class="ellipse"> 车辆：{{ (data.carInfoObj && data.carInfoObj.plate) || '' }} | {{ (data.carInfoObj && data.carInfoObj.model) || '' }}</span>
          </template>
        </div>
        <!-- <div class="dealerName ellipsis">
          车龄:
          {{
            data.carInfoObj && data.carInfoObj.carAge
              ? `${data.carInfoObj && data.carInfoObj.carAge}年`
              : data.carInfoObj && data.carInfoObj.carAge === 0
              ? '新车'
              : '待确认'
          }}
        </div> -->
        <div class="dealerName ellipsis">
          <template v-if="data.carInfoObj && data.carInfoObj.intention">
            VIN：未识别
          </template>
          <template v-else> VIN: {{ (data.carInfoObj && data.carInfoObj.vin) || '' }} </template>
        </div>
        <div class="dealerName ellipsis">
          <template v-if="data.carInfoObj && data.carInfoObj.intention">
            FIN：未识别
          </template>
          <template v-else> FIN: {{ (data.carInfoObj && data.carInfoObj.fin) || '待确认' }} </template>
        </div>
        <div class="dealerName ">购买经销商: {{ data.dealerName }}</div>
        <div class="dealerName ">经销商地址: {{ (data.dealerInfo && data.dealerInfo.address) || '' }}</div>
      </div>
      <div @click.stop>
        <template v-if="data?.carInfoObj?.intention">
          <div>
            <span class="priceNum priceWeight priceWidth"> ¥{{ data.depositPrice || 0 }} </span>
            <span class="priceNum priceText" :style="[{ 'font-size': '0.4rem' }, { color: data.productType == 4 ? '#3088c5' : '' }]">
              意向金*
            </span>
          </div>
          <div style="margin-top:5px">
            <span class="priceNum ">(¥{{ data.price }} 起<span style="margin-left: 0.4rem;">厂商建议零售价</span>)</span>
          </div>
        </template>
        <template v-else>
          <span class="priceNum priceWeight"> ¥{{ data.selfPrice }} </span>
          <span class="priceNum"> 厂商建议零售价* </span>
        </template>
      </div>
      <van-field v-model="profiles" label="备注:" maxlength="20" size="small" label-width="40px" placeholder="您可以输入备注内容（20字以内）" />
    </div>
  </div>
</template>

<script>
import { reactive, toRefs, computed, watch } from 'vue'

export default {
  props: {
    data: {
      type: [Object, Array],
      default: () => []
    },
    priceWeight: {
      type: Boolean,
      default: false
    },
    hiddenPrice: {
      type: Boolean,
      default: false
    },
    profile: {
      type: String,
      default: ''
    }
  },
  components: {},
  emits: ['clickCard', 'clickImg', 'getProfile'],
  setup(props, { emit }) {
    let { data, priceWeight, profile } = toRefs(props)
    const state = reactive({
      profiles: profile.value,
      data: data.value,
      priceWeight: priceWeight.value
    })
    watch(
      () => state.profiles,
      n => {
        emit('getProfile', n)
      }
    )
    const isArrayFn = value => {
      if (typeof Array.isArray === 'function') {
        return Array.isArray(value)
      } else {
        return Object.prototype.toString.call(value) === '[object Array]'
      }
    }
    const productsData = computed(() => (isArrayFn(data.value) ? data.value : [data.value]))
    return {
      ...toRefs(state),
      productsData
    }
  }
}
</script>
<style lang="scss" scoped>
.ellipse {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 200px;
  display: block;
}
.imgBox,
.imgBox img {
  position: relative;
  display: inline-block;
  width: 99px;
  height: 74px;
  vertical-align: top;
}
.cartItem {
  display: inline-block;
  // width: calc(100% - 20px);
  font-size: 12px;
  color: #999;
}
.orderIfnBox {
  display: inline-block;
  padding-left: 8px;
  width: calc(100% - 110px);
}
.planName {
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 4px;
  color: #333;
  font-weight: 600;
}
.dealerNameBox {
  padding: 5px;
  margin-bottom: 8px;
  line-height: 16px;
  // background-color: #f9f9f9;
}
.dealerName {
  margin-bottom: 5px;
}

.priceNum {
  color: #666666;
}
.priceNum + .priceNum {
  margin-left: 16px;
  color: #666666;
}
.priceWeight {
  font-size: 16px;
  font-weight: 600;
  color: #3088c5;
}
.priceWidth {
  width: 90px;
  display: inline-block;
}
.priceText {
  margin-left: 0px !important;
  width: 102px;
  display: inline-block;
  //text-align: right;
}
::v-deep .van-field__label {
  font-size: 13px !important;
}
::v-deep .van-field__control::-webkit-input-placeholder {
  color: #757575;
  font-size: 9px !important;
  font-weight: 400;
}
</style>
